import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { HbSharedModule } from '../hb-shared.module';
import { DirtyFormDialogComponent } from './dirty-form-dialog.component';

@NgModule({
  imports: [HbSharedModule, I18NextModule.forRoot()],
  declarations: [DirtyFormDialogComponent],
  exports: [DirtyFormDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [DirtyFormDialogComponent],
})
export class DirtyFormDialogModule { }
